import { autorun } from 'mobx';
import { useState, useEffect } from 'react';
import CreatePortfolioModalStore from 'store/modules/proposal/ui/createPortfolioModalStore';
import ProposalPageStore from 'store/pages/proposal/pageStore';
import { useProductLineDelegate } from 'store/pages/proposal/productLineContext';
import { useRootStore } from 'store/rootStore';

export default function useCreatePortfolioModalStore(): CreatePortfolioModalStore<ProposalPageStore> {
  const { proposalPageStore } = useRootStore();
  const productLineDelegate = useProductLineDelegate();

  const [store, setStore] = useState(
    () => new CreatePortfolioModalStore({ pageStore: proposalPageStore, productLineDelegate }),
  );

  useEffect(() => {
    const disposer = autorun(() => {
      setStore(new CreatePortfolioModalStore({ pageStore: proposalPageStore, productLineDelegate }));
    });

    return (): void => disposer();
  }, [productLineDelegate, proposalPageStore]);
  return store;
}
